<script>
import { mapGetters, mapMutations } from 'vuex';
import SimplePlaceholder from '../../kit/SimplePlaceholder.vue';

export default {
  name: 'CompareHeader',
  components: { SimplePlaceholder },
  computed: {
    ...mapGetters({
      products: 'compare/products',
      highlightDifferences: 'compare/highlightDifferences',
    }),
    isLoading() {
      return !this.products || this.products.length === 0;
    },
  },
  methods: {
    ...mapMutations({
      toggleHighlights: 'compare/TOGGLE_DIFFERENCES',
    }),
  },
};
</script>

<template>
  <div class="flex items-center justify-between">
    <div>
      <SimplePlaceholder v-if="isLoading" />
      <div class="text-gray-900 font-bold text-xl" v-else>
        {{ $tc('products_compared', products.length, { number: products.length }) }}
      </div>
    </div>

    <div>
      <SimplePlaceholder v-if="isLoading" />

      <div class="flex items-center" @click="toggleHighlights" v-else>
        <div
          class="font-bold text-sm"
          :class="{
            'text-gray-700': highlightDifferences,
            'text-gray-500': !highlightDifferences
          }"
        >
          {{ $t('highlight_differences') }}
        </div>
        <div class="ml-2 w-9 h-5 flex items-center bg-gray-300 rounded-full p-1
          duration-300 ease-in-out" :class="{ 'bg-green-400': highlightDifferences}">
          <div class="bg-white w-4 h-4 rounded-full shadow-md transform
            duration-300 ease-in-out" :class="{ 'translate-x-3': highlightDifferences}"></div>
        </div>
      </div>
    </div>
  </div>
</template>
